import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';

export default function PrinterSelect({
  printers,
  selectedPrinter,
  storedPrinter,
  unavailable,
  loading,
  error,
  onChange,
  fullWidth = false,
  size = 'small',
}) {
  const value = selectedPrinter?.printer_uid || '';

  return (
    <Stack spacing={0.75} sx={{ minWidth: fullWidth ? 0 : 260, width: fullWidth ? '100%' : 'auto' }}>
      <FormControl fullWidth={fullWidth} size={size} disabled={loading || !printers.length}>
        <InputLabel>Принтер</InputLabel>
        <Select
          value={value}
          label="Принтер"
          onChange={(event) => onChange(event.target.value)}
          renderValue={() => selectedPrinter?.name || storedPrinter?.label || 'Выберите принтер'}
        >
          {printers.map((printer) => (
            <MenuItem key={printer.printer_uid} value={printer.printer_uid}>
              <Stack>
                <Typography variant="bodyMedium">{printer.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  {printer.location || printer.agent?.hostname || printer.agent?.name || printer.port_name || 'Print-agent online'}
                </Typography>
              </Stack>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {unavailable && (
        <Alert severity="warning">
          Принтер «{storedPrinter?.label}» недоступен или агент offline. Выберите принтер заново.
        </Alert>
      )}
      {!loading && !error && !printers.length && (
        <Typography variant="bodySmall" color="warning.main">
          Нет доступных принтеров. Проверьте Windows print-agent.
        </Typography>
      )}
      {error && <Typography variant="bodySmall" color="error.main">{error}</Typography>}
    </Stack>
  );
}
